<template>
  <section class="section">
    <form @submit.prevent="validateBeforeSubmit">
      <div class="container">
        <div class="columns">
          <div class="column is-10">
            <h1 class="title green">
              <span v-if="order.id != null && order.id != 0 && order.id != -1">
                {{ order.primaryCode }}
              </span>
              <span v-else>{{ title }}</span> - {{ patient.name }} -
              <span v-if="patient.shopData">{{ patient.shopData.name }}</span> -
              {{ $translate(currentStatus) | capitalize }}
            </h1>
          </div>
          <div class="column has-text-right">
            <b-field grouped position="is-right">
              <b-field>
                <a
                  v-if="order.id != null && order.id != 0 && order.id != -1 && $store.getters.user.userInfo.type != 'C'"
                  type="button"
                  class="button is-primary"
                  @click="downloadAttach()"
                >
                  <b-icon icon="download-outline" />
                </a>
              </b-field>
              <b-field>
                <a
                  v-if="order.id != null && order.id != 0 && order.id != -1"
                  type="button"
                  class="button is-danger"
                  :disabled="isDeletableBool || disabledbool"
                  @click="
                    if (!isDeletableBool && !disabledbool) {
                      deleteOccurence(order.id)
                    }
                  "
                >
                  <b-icon icon="delete-outline" />
                </a>
              </b-field>
              <b-field>
                <b-dropdown aria-role="list" position="is-bottom-left">
                  <button
                    slot="trigger"
                    type="button"
                    class="button is-primary"
                    :disabled="isSaveDisabled || disabledbool"
                  >
                    <b-icon icon="content-save-outline" />
                  </button>

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="validateBeforeSubmit(true)">
                    {{ $translate('save') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item class="pointercursor" @click="tryvalidate()">
                    {{ $translate('check') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />

                  <b-dropdown-item class="pointercursor" :disabled="disabledbool" @click="trysave('invord')">
                    <!--:disabled="disabledbool || isEnvoiableBool"-->
                    {{ $translate('save_envo') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    class="pointercursor"
                    :disabled="disabledbool || $store.getters.user.userInfo.level == '1'"
                    @click="trysave('sendord')"
                  >
                    <!--:disabled="disabledbool || isSendableBool"-->
                    {{ $translate('save_sended') | capitalize }}
                  </b-dropdown-item>

                  <hr class="dropdown-divider" />
                  <b-dropdown-item class="pointercursor" @click="printOrderFunction()">
                    <!--:disabled="currentStatus == 'compord'"-->
                    {{ $translate('print') | capitalize }}
                  </b-dropdown-item>
                  <hr v-if="!order.company.simplifiedOrder" class="dropdown-divider" />
                  <b-dropdown-item
                    v-if="!order.company.simplifiedOrder"
                    class="pointercursor"
                    @click="exportJson() /*console.log('TODO EXPORT')*/"
                  >
                    <!--:disabled="currentStatus == 'compord'"-->
                    {{ $translate('export') | capitalize }}
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="!order.company.simplifiedOrder"
                    class="pointercursor"
                    :disabled="sendingToMercurio"
                    @click="sendToMercurio()"
                  >
                    {{ $translate('send_to_mercurio') | capitalize }}
                  </b-dropdown-item>
                </b-dropdown>
              </b-field>
            </b-field>
          </div>
        </div>
        <hr />

        <b-tabs v-model="activeTab" position="is-left" class="blocks" @input="changePage">
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[0] }" icon="information-outline" />
              <span :class="{ 'has-text-danger': pageWarning[0] }"> {{ $translate('generalInfo') }}</span>
            </template>
            <div class="container">
              <OrderGeneralInfo
                :order.sync="order"
                :config="config"
                :patient.sync="patient"
                :pathologiesbool.sync="pathologiesbool"
                :status.sync="$status[order.module]"
                :disabledbool.sync="disabledbool"
                :current-status.sync="currentStatus"
                :is-save-disabled.sync="isSaveDisabled"
                :language.sync="language"
                :is-simplified.sync="order.company.simplifiedOrder"
              />
            </div>
          </b-tab-item>

          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[1] }" icon="file-outline" />
              <span :class="{ 'has-text-danger': pageWarning[1] }"> {{ $translate('orderTypetext') }}</span>
            </template>

            <div class="container">
              <OrderTypology
                ref="OrderTypology"
                :order.sync="order"
                :bdictionary.sync="bdictionary"
                :b-dictionary-name.sync="bDictionaryName"
                :ddictionary.sync="ddictionary"
                :d-dictionary-name.sync="dDictionaryName"
                :disabledbool.sync="disabledbool"
                :is-simplified.sync="order.company.simplifiedOrder"
                @updateParent="updateChild()"
              />
              <br /><br /><br /><br />

              <h3 class="green subtitle">
                {{ $translate('subtitle_form_order_production') }}
              </h3>
              <hr />
              <!--<AddMaterial
                ref="AddMaterialprod"
                :availablematerial.sync="$availablematerialprod"
                :materialarray.sync="order.materialprod"
                :disabledbool.sync="disabledbool"
                :card2.sync="order.orderTypeVariant + 'no'"
                :material-type="'production'"
              />-->
              <ManageMaterials
                ref="ManageMaterialProd"
                :availablematerial.sync="$availablematerialprod"
                :materials.sync="order.materialprod"
                :disabledbool="disabledbool"
                :card2="`${order.orderTypeVariant}no`"
                :material-type="'production'"
              />

              <h3 class="green subtitle">
                {{ $translate('subtitle_form_order_companion') }}
              </h3>
              <hr />
              <!--<AddMaterial
                ref="AddMaterialacc"
                :availablematerial.sync="$availablematerialacc"
                :materialarray.sync="order.materialacc"
                :disabledbool.sync="disabledbool"
                :card2.sync="order.orderTypeVariant"
                :material-type="'project'"
              />-->
              <ManageMaterials
                ref="ManageMaterialAcc"
                :availablematerial.sync="$availablematerialacc"
                :materials.sync="order.materialacc"
                :disabledbool="disabledbool"
                :card2="order.orderTypeVariant"
                :material-type="'project'"
              />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[2] }" icon="book-open-outline" />
              <span :class="{ 'has-text-danger': pageWarning[2] }"> {{ $translate('model') | capitalize }}</span>
            </template>
            <div class="container">
              <OrderModel
                :config="config"
                ref="OrderModel"
                :mod.sync="order.mod"
                :availablepell.sync="availablepell"
                :availablefode.sync="availablefode"
                :availablebatt.sync="availablebatt"
                :availableinter.sync="availableinter"
                :availableguard.sync="availableguard"
                :availablegomm.sync="availablegomm"
                :availablecont.sync="availablecont"
                :availablesott.sync="availablesott"
                :availablepunt.sync="availablepunt"
                :availableallacc.sync="availableallacc"
                :shoe-type.sync="order.shoeType"
                :catalog-type.sync="order.catalogType"
                :disabledbool.sync="disabledbool"
                :catalog-model.sync="catalog.model"
                :is-save-disabled.sync="isSaveDisabled"
                :is-simplified.sync="order.company.simplifiedOrder"
                :is-custom-hidden.sync="order.company.hideCustom"
                :order.sync="order"
                @getid="getid"
              />
            </div>
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[3] }" icon="view-dashboard-outline" />
              <span :class="{ 'has-text-danger': pageWarning[3] }"> {{ $translate('measure_text') | capitalize }}</span>
            </template>
            <Measurements
              ref="Measurements"
              :order.sync="order"
              :availablemoi.sync="availablemoi"
              :availablesup_plan.sync="availablesup_plan"
              :availableriv_plan.sync="availableriv_plan"
              :availablepel.sync="availablepel"
              :arraytodelete.sync="arraytodelete"
              :disabledbool.sync="disabledbool"
              :is-simplified.sync="order.company.simplifiedOrder"
              :missingattachment.sync="missingattachment"
            />
          </b-tab-item>
          <b-tab-item>
            <template slot="header">
              <b-icon :class="{ 'has-text-danger': pageWarning[4] }" icon="card-account-details-outline" />
              <span :class="{ 'has-text-danger': pageWarning[4] }"> {{ $translate('prod_details') }}</span>
            </template>
            <ProdDetails
              :order.sync="order"
              :disabledbool.sync="disabledbool"
              :availablecont.sync="availablecont"
              :availablesott.sync="availablesott"
              :availablepunt.sync="availablepunt"
              :availablereinforcement.sync="availablereinforcement"
            />
          </b-tab-item>
        </b-tabs>
      </div>
    </form>
    <PrintOrder :print-order-bool.sync="printOrderBool" :orders.sync="printOrders" />

    <b-loading :is-full-page="true" :active.sync="isSaveDisabled" :can-cancel="false" />
  </section>
</template>

<script>
import '@/helpers/mixins/variables/availablematerialprod'
import '@/helpers/mixins/variables/availablematerialacc'
import '@/helpers/mixins/variables/ordertype'
import '@/helpers/mixins/variables/deliverytype'

import { modelTailored } from '@/helpers/mixins/modelTools'
import orderTools from '@/helpers/mixins/orderTools'
import materialTools from '@/helpers/mixins/materialTools'
import exportTools from '@/helpers/mixins/exportTools'
import permissionMixin from '@/helpers/mixins/permissionMixin'

import OrderGeneralInfo from './components/OrderGeneralInfo'
import OrderTypology from './components/OrderTypology'
//import AddMaterial from "./components/AddMaterial";
import OrderModel from './components/OrderModel'
import Measurements from './components/Measurements'
import ProdDetails from './components/ProdDetails'
import PrintOrder from './components/PrintOrder'
import ManageMaterials from './components/ManageMaterials.vue'

import firebase from 'firebase'
import keyWordGenerator from '@/helpers/mixins/keyWordGenerator.js'

import { required, numeric, min_value, max_value } from 'vee-validate/dist/rules.esm'
import JSZip from 'jszip'
import saveAs from 'file-saver'
//import cloneDeep from "clone-deep";
import { cloneDeep, isEqual } from 'lodash'
//import request from "request";

export default {
  $_veeValidate: {
    validator: 'new',
  },
  name: 'OrderForm',
  components: {
    OrderGeneralInfo: OrderGeneralInfo,
    OrderTypology: OrderTypology,
    //AddMaterial: AddMaterial,
    OrderModel: OrderModel,
    Measurements: Measurements,
    ProdDetails: ProdDetails,
    PrintOrder: PrintOrder,
    ManageMaterials: ManageMaterials,
  },
  mixins: [orderTools, materialTools, permissionMixin, keyWordGenerator, exportTools],
  // props: ["orderId"],
  props: {
    orderId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      missingattachment: false,
      printOrderBool: false,
      printOrders: null,
      catalog: {},
      disabledbool: false,
      sendingToMercurio: false,
      currentStatus: null,
      pathologiesbool: null,
      bdictionary: null,
      bDictionaryName: '',
      dDictionaryName: '',
      ddictionary: null,
      pageWarning: [false, false, false, false, false],
      arraytoupload: {},
      arraytodelete: {},
      loadingData: false,
      id: -1,
      tempid: -1,
      patientId: -1,
      patient: {},
      title: 'Form Ordine',
      activeTab: 0,
      isSaveDisabled: false,
      isDeletableBool: true,
      isEnvoiableBool: true,
      isSendableBool: true,

      availablepell: [],
      availablefode: [],
      availablebatt: [],
      availableinter: [],
      availableguard: [],
      availablegomm: [],

      availablecont: [],
      availablesott: [],
      availablepunt: [],
      availablereinforcement: [],

      availablemoi: [],
      availablesup_plan: [],
      availableriv_plan: [],

      availableallacc: [],

      availablepel: [],

      lastSavedOrder: {},

      order: {
        id: null,
        plan_realization: 'no_plantar',
        isDunaInsoleDisabledSx: false,
        isDunaInsoleDisabledDx: false,
        statusOrder: 'compord',
        send_date: null,

        pair: 'both',
        //prec_pair: "empty",

        primaryCode: null,
        catalogType: null,
        shoeType: null,

        orderType: null,
        orderTypeMain: null,
        orderTypeVariant: null,
        orderTypeSubVariant: null,
        deliverySelected: null,
        deliverySelectedSub: null,

        patientId: null,
        creationDate: null,
        lastModificationDate: null,

        pathologiesLeft: [],
        pathologiesRight: [],

        materialprod: [],
        materialacc: [],

        module: 'tailored',
        isPrinted: false,

        mod: {
          components_to_drill: [],
          addingchar: [],
          addingcharfod: [],
          var_ling_sx: [],
          var_ling_dx: [],
        },
        footmeasurements: {
          c_pair: 'not_spec',
        },
        attachment: {},
        attachmentflag: {},

        company: {
          simplifiedOrder: false,
        },
      },
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    config() {
      return this.$moduleConfiguration[this.order.module]
    },
  },
  watch: {
    order: {
      deep: true,
      handler() {
        this.isDeletableBool = this.isTransitionDoable(this.currentStatus, 'deletedord', this.order) == false
        this.isEnvoiableBool = this.isTransitionDoable(this.currentStatus, 'invord', this.order) == false
        this.isSendableBool = this.isTransitionDoable(this.currentStatus, 'sendord', this.order) == false
        this.$forceUpdate()
      },
    },
  },
  async mounted() {
    try {
      await this.initForm()
    } catch (error) {
      this.isSaveDisabled = false
      this.loadingData = false
      this.$buefy.notification.open({
        duration: 5000,
        message: this.$translate('order_loading_error'),
        type: 'is-danger',
      })
      throw error
    }
  },
  methods: {
    async initForm() {
      this.isSaveDisabled = true
      this.disabledbool = !this.$route.params.view

      //const cloneDeep = require("clone-deep");

      this.$validator.extend('notnull', value => {
        if (value == '' || value == undefined) {
          return false
        }
        return true
      })

      this.$validator.extend('unique', async value => {
        var temparray = []
        await this.$db
          .collection('orders')
          .where('primaryCode', '==', value)
          .get()
          .then(snapshot => {
            snapshot.forEach(doc => {
              if (doc.id != this.id) {
                temparray.push(doc.data().primaryCode)
              }
            })
          })

        if (temparray.includes(value)) {
          return false
        }
        return true
      })
      this.patientId = this.$route.params.patientId != undefined ? this.$route.params.patientId : -1
      this.id = this.orderId ? this.orderId : -1

      /*for (var ind in this.$availableMaterials) {
        this.order.materialprod[this.$availableMaterials[ind]] = 0;
        this.order.materialacc[this.$availableMaterials[ind]] = 0;
      }*/

      //this.order.mod = new modelTailored();
      //this.order.mod = this.order.mod.returnObject();
      //this.order.mod.catalogchoose = true;
      //let oldmod = cloneDeep(this.order.mod);
      let oldmod = new modelTailored().returnObject()
      oldmod.catalogchoose = true

      if (this.patientId != -1) {
        this.order.patientId = this.patientId
      } else {
        if (this.id == -1) {
          this.$router.push({ name: 'patients' })
        }
      }
      /*
      await this.getMaterialArray(this.availablepell, "Pel");
      await this.getMaterialArray(this.availablefode, "Acc");
      await this.getMaterialArray(this.availablebatt, "Pun");
      await this.getMaterialArray(this.availableinter, "Mor");
      await this.getMaterialArray(this.availableguard, "Mat");
      await this.getMaterialArray(this.availablegomm, "Sug");
      await this.getMaterialArray(this.availablecont, "PaS");
      await this.getMaterialArray(this.availablesott, "Pat");
      await this.getMaterialArray(this.availablepunt, "Mez");

      await this.getMaterialArray(this.availablemoi, "Moi");
      await this.getMaterialArray(this.availablesup_plan, "Sup_plan");
      await this.getMaterialArray(this.availableriv_plan, "Riv_plan");
      */
      this.loadingData = true
      if (this.id != -1) {
        await this.$db
          .collection('orders')
          .doc(this.id)
          .get()
          .then(doc => {
            if (!doc.exists) {
              this.lastSavedOrder = cloneDeep(this.order)
              this.$router.push({ name: 'orders' })
            }
            let orderData = doc.data()
            orderData.module = orderData.module || 'tailored'
            orderData.mod.components_to_drill = orderData.mod.components_to_drill || []
            orderData.mod.addingchar = orderData.mod.addingchar || []
            orderData.mod.addingcharfod = orderData.mod.addingcharfod || []
            orderData.mod.var_ling_sx = orderData.mod.var_ling_sx || []
            orderData.mod.var_ling_dx = orderData.mod.var_ling_dx || []

            if (!orderData.pair) orderData.pair = 'both'

            for (const key of [
              'orderType',
              'orderTypeMain',
              'orderTypeVariant',
              'orderTypeSubVariant',
              'deliverySelected',
              'deliverySelectedSub',
            ]) {
              if (orderData[key] === undefined) orderData[key] = null
            }
            orderData.isDunaInsoleDisabledSx = !!orderData.isDunaInsoleDisabledSx
            orderData.isDunaInsoleDisabledDx = !!orderData.isDunaInsoleDisabledDx

            //this.order = doc.data();
            //console.log(orderData.materialacc)
            //console.log(orderData.materialprod)
            if (Object.keys(orderData.materialacc).length == 0) orderData.materialacc = []
            if (Object.keys(orderData.materialprod).length == 0) orderData.materialprod = []
            //console.log(orderData.materialacc)
            //console.log(orderData.materialprod)
            this.order = orderData
            oldmod = cloneDeep(this.order.mod)

            if (this.order.attachment == null) {
              this.order.attachment = {}
            }

            if (this.order.attachmentflag == null) {
              this.order.attachmentflag = {}
            }

            /*if (!this.isEditDoable(this.order.statusOrder)) {
              this.$router.push({ name: "orders" });
            }*/
          })

        this.patientId = this.order.patientId

        await this.loadPatientStatfromOrder()
        //console.log(this.ddictionary)
      } else {
        this.order.mod = new modelTailored()
        this.order.mod = this.order.mod.returnObject()
        this.order.mod.catalogchoose = true

        await this.loadPatientStat()
        if (this.$route.params.startingorderType) {
          this.order.orderType = this.$route.params.startingorderType
        }
      }
      if (this.order.tec == null) {
        this.order.tec = this.$store.getters.user.userInfo.username
      }

      this.order.patient = this.patient
      this.currentStatus = this.order.statusOrder
      if (this.catalog == undefined) {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('catalog_missing'),
          type: 'is-danger',
        })
        this.lastSavedOrder = cloneDeep(this.order)

        this.$router.push({ name: 'orders' })
      }

      await this.getMaterialArrayFiltered(this.availablepell, 'Pel', this.catalog)

      await this.getMaterialArrayFiltered(this.availablefode, 'Acc', this.catalog)
      await this.getMaterialArrayFiltered(this.availablebatt, 'Pun', this.catalog)
      await this.getMaterialArrayFiltered(this.availableinter, 'Mor', this.catalog)
      await this.getMaterialArrayFiltered(this.availableguard, 'Mat', this.catalog)
      await this.getMaterialArrayFiltered(this.availablegomm, 'Sug', this.catalog)
      await this.getMaterialArrayFiltered(this.availablecont, 'PaS', this.catalog)
      await this.getMaterialArrayFiltered(this.availablesott, 'Pat', this.catalog)
      await this.getMaterialArrayFiltered(this.availablepunt, 'Mez', this.catalog)
      await this.getMaterialArrayFiltered(this.availablereinforcement, 'reinforcement', this.catalog)

      await this.getMaterialArrayFiltered(this.availablemoi, 'Moi', this.catalog)
      await this.getMaterialArrayFiltered(this.availablesup_plan, 'Sup_plan', this.catalog)
      await this.getMaterialArrayFiltered(this.availableriv_plan, 'Riv_plan', this.catalog)

      await this.getMaterialArrayFiltered(this.availableallacc, 'Mod', this.catalog)

      await this.getMaterialArrayFiltered(this.availablepel, 'Pelo', this.catalog)

      //this.$refs.AddMaterialprod.updateAfterload();
      //this.$refs.AddMaterialacc.updateAfterload();

      this.order.mod = cloneDeep(oldmod)
      this.$refs.OrderModel.updateAfterload()
      //console.log('QUESTO')
      //console.log(this.$refs.Measurements)
      this.$refs.Measurements.checkValue()

      //this.lastSavedOrder = cloneDeep(this.order);
      this.lastSavedOrder = cloneDeep(this.order)
      //console.log(isEqual(this.order, this.lastSavedOrder));
      //console.log(isMatch())

      this.loadingData = false

      this.$forceUpdate()
    },
    updateChild() {
      this.$forceUpdate()
      if (this.$refs.Measurements) {
        this.$refs.Measurements.checkValue()
      }
      if (this.$refs.OrderModel) {
        this.$refs.OrderModel.deliveryUpdated()
      }
    },
    printOrderFunction() {
      this.printOrders = []
      this.printOrders.push(this.order)
      this.printOrderBool = true
    },
    async getid(tempid) {
      this.tempid = tempid
      //console.log(tempid);
    },
    checkValidation() {
      //let valuetoreturn = this.isSendable(this.order)
      //valuetoreturn = !valuetoreturn
      //return valuetoreturn
      return !this.checkSend(this.order)
    },
    async downloadAttach() {
      const cloneDeep = require('clone-deep')

      this.isSaveDisabled = true
      var zip = new JSZip()
      for (var item in this.order.attachment) {
        if (this.order.attachment[item] != null) {
          if (this.order.attachment[item].name) {
            //
          } else {
            //console.log(item);
            let oldmeta = ''
            const storageRef = this.$storage.ref('order/attachment/' + this.order.id + '/' + item)
            await storageRef.getMetadata().then(metadata => {
              oldmeta = metadata.contentType
            })
            if (item.substring(item.length - 6, item.length - 3) == 'pln') {
              oldmeta = 'pln'
            } else if (item.substring(item.length - 6, item.length - 3) == 'fms') {
              oldmeta = 'fms'
            } else if (item.substring(item.length - 6, item.length - 3) == 'stl') {
              oldmeta = 'stl'
            } else if (item.substring(item.length - 6, item.length - 3) == 'una') {
              oldmeta = 'stl'
            } else {
              oldmeta = oldmeta.substr(oldmeta.length - 3)
              if (oldmeta == 'peg') {
                oldmeta = 'jpeg'
              }
            }
            await storageRef.getDownloadURL().then(async url => {
              await fetch(url).then(async htmlReturn => {
                let previousChunk = new Uint8Array()
                let fileArray = new Uint8Array()
                const reader = htmlReturn.body.getReader()
                await reader
                  .read()
                  .then(function appendStreamChunk({ done, value }) {
                    if (value) {
                      previousChunk = cloneDeep(fileArray)
                      fileArray = new Uint8Array(previousChunk.length + value.length)
                      fileArray.set(previousChunk)
                      fileArray.set(value, previousChunk.length)
                    }
                    if (done) {
                      return fileArray
                    } else {
                      return reader.read().then(appendStreamChunk)
                    }
                  })
                  .then(async file => {
                    zip.file(item + '.' + oldmeta, file)
                  })
                  .catch()
              })
            })
          }
        }
      }
      zip.generateAsync({ type: 'blob' }).then(content => {
        saveAs(
          content,
          this.$store.getters.user.userInfo.name +
            this.$store.getters.user.userInfo.surname +
            new Date().toLocaleDateString() +
            '.zip'
        )
      })
      this.isSaveDisabled = false
    },
    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('order_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('order_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(idtoerase)
            .set(
              {
                statusOrder: 'deletedord',
                deleted: true,
              },
              { merge: true }
            )
            .then(() => {
              this.lastSavedOrder = cloneDeep(this.order)

              this.$router.push({ name: 'orders' })
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            }),
      })
    },
    changePage(index) {
      this.pageWarning[index] = false
    },
    trysave(newstatus) {
      if (newstatus !== 'compord' && newstatus !== 'deletedord' && !this.checkSend(this.order)) {
        this.checkMissingAttachment()
        this.setStrictValidationRules()
        this.$validator.validateAll().then(() => this.$forceUpdate())
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
        return
      }
      if (this.canUserDoTransition(this.order.statusOrder, newstatus)) {
        if (this.$store.getters.user.userInfo.type == 'C' && this.$store.getters.user.userInfo.level == '1') {
          if (newstatus == 'invord') {
            this.$validator.validateAll().then(result => {
              if (result) {
                this.$buefy.dialog.confirm({
                  title: this.$translate('attention'),
                  message: this.$translate('confirm_invord_C1'),
                  cancelText: this.$translate('undo'),
                  confirmText: this.$translate('confirm'),
                  type: 'is-danger',
                  hasIcon: true,
                  onConfirm: () => {
                    this.order.statusOrder = newstatus
                    this.validateBeforeSubmit()
                  },
                })
                return
              }
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('failed_form'),
                type: 'is-danger',
              })
            })
          } else {
            this.order.statusOrder = newstatus
            this.validateBeforeSubmit()
          }
        } else {
          if (this.$store.getters.user.userInfo.type == 'C') {
            if (newstatus == 'sendord') {
              this.$validator.validateAll().then(result => {
                if (result) {
                  this.$buefy.dialog.confirm({
                    title: this.$translate('attention'),
                    message: this.$translate('confirm_sendord_C'),
                    cancelText: this.$translate('undo'),
                    confirmText: this.$translate('confirm'),
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                      this.order.statusOrder = newstatus
                      this.validateBeforeSubmit()
                    },
                  })
                  return
                }
                this.$buefy.notification.open({
                  duration: 3000,
                  message: this.$translate('failed_form'),
                  type: 'is-danger',
                })
              })
            } else {
              this.order.statusOrder = newstatus
              this.validateBeforeSubmit()
            }
          } else {
            this.order.statusOrder = newstatus
            this.validateBeforeSubmit()
          }
        }
      } else {
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('changeStatusNotPermitted'),
          type: 'is-danger',
        })
      }
    },
    notifySuccess() {
      this.$buefy.notification.open({
        duration: 3000,
        message: this.$translate('success_form'),
        type: 'is-success',
      })
    },
    checkMissingAttachment() {
      const attachment = this.order.attachment
      const pair = this.order.pair
      let missing = false
      if (this.order.orderTypeMain == 'digitalMeasurements' && this.order.orderTypeVariant != 'formproj') {
        const dunaComplete =
          attachment.scan_fms_sx != null &&
          attachment.scan_pln_sx != null &&
          attachment.scan_stl_sx != null &&
          attachment.scan_fms_dx != null &&
          attachment.scan_pln_dx != null &&
          attachment.scan_stl_dx != null
        const scanComplete = attachment.scan_no_duna_sx != null && attachment.scan_no_duna_dx != null
        missing = !dunaComplete && !scanComplete
      } else if (this.order.orderTypeMain == 'digitalMeasurements' && this.order.orderTypeVariant == 'formproj') {
        missing = attachment.scan_no_duna_sx == null || attachment.scan_no_duna_dx == null
      } else if (
        this.order.orderTypeMain == 'last' &&
        this.order.orderTypeVariant == 'formplusplant' &&
        this.order.orderTypeSubVariant == 'file3D'
      ) {
        missing =
          (pair !== 'right' && attachment.scan_no_duna_sx == null) ||
          (pair !== 'left' && attachment.scan_no_duna_dx == null)
      } else if (this.order.orderTypeMain == 'measurements') {
        missing = (pair !== 'right' && attachment.grap_sx == null) || (pair !== 'left' && attachment.grap_dx == null)
      }
      this.missingattachment = missing
      return missing
    },
    tryvalidate() {
      this.checkMissingAttachment()
      this.$validator.validateAll().then(result => {
        if (result && !this.missingattachment && this.checkSend(this.order)) {
          this.notifySuccess()
          return
        }
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
    },
    setRelaxedValidationRules() {
      this.$validator.extend('from1to100', () => {
        return true
      })
      this.$validator.extend('from15to80', () => {
        return true
      })
      this.$validator.extend('from5to130', () => {
        return true
      })
      this.$validator.extend('from70to500', () => {
        return true
      })
      this.$validator.extend('threeneeding', () => {
        return true
      })
      this.$validator.extend('required', () => {
        return true
      })
      this.$validator.extend('min_value', () => {
        return true
      })
      this.$validator.extend('max_value', () => {
        return true
      })
      this.$validator.extend('nooneSelected', () => {
        return true
      })
      this.$validator.extend('numeric', value => {
        if (value == null || value == '' || value == undefined) {
          return false
        } else {
          return !isNaN(parseFloat(value)) && isFinite(value)
        }
      })
    },
    setStrictValidationRules() {
      this.$validator.extend('required', required)
      this.$validator.extend('numeric', numeric)
      this.$validator.extend('min_value', min_value)
      this.$validator.extend('max_value', max_value)
      this.$validator.extend('nooneSelected', value => {
        if (value == 'Noone') return false
        return true
      })
      this.$validator.extend('from1to100', value => {
        if (value <= 100 && value >= 1) {
          return true
        }
        return false
      })
      this.$validator.extend('from15to80', value => {
        if (value <= 80 && value >= 15) {
          return true
        }
        return false
      })
      this.$validator.extend('from5to130', value => {
        if (value <= 130 && value >= 5) {
          return true
        }
        return false
      })
      this.$validator.extend('from70to500', value => {
        if (value <= 500 && value >= 70) {
          return true
        }
        return false
      })
      this.$validator.extend('threeneeding', value => {
        if (value.length == 3 || value.length == 0) {
          return true
        }
        return false
      })
    },
    validateBeforeSubmit(simpleSave = false) {
      this.checkSend(this.order)
      const isRelaxed =
        this.order.statusOrder == 'compord' || (simpleSave === true && this.order.statusOrder == this.currentStatus)
      if (isRelaxed) this.setRelaxedValidationRules()
      this.$validator.validateAll().then(result => {
        //console.log(this.$validator);
        if (result) {
          if (
            this.order.statusOrder != 'compord' &&
            this.order.statusOrder != 'invord' &&
            this.order.send_date == null
          ) {
            this.order.send_date = new Date().getTime()
          }

          this.InitUpdate()
          return
        }
        this.$forceUpdate()
        this.$buefy.notification.open({
          duration: 3000,
          message: this.$translate('failed_form'),
          type: 'is-danger',
        })
      })
      if (isRelaxed) this.setStrictValidationRules()
    },
    async InitUpdate() {
      this.isSaveDisabled = true
      this.order.searchArray = this.generateArrayFromOrder(this.order)
      //console.log(this.order.searchArray)
      this.order.scans_sx = []
      this.order.scans_dx = []

      //Hotfix: anticipata la creazione dell'array "arraytoupload" per evitare il problema del salvataggio non più possibile di FILE in una chiave del DB Firebase
      for (const item in this.order.attachment) {
        if (this.order.attachment[item]) {
          if (this.order.attachmentflag[item] === 0) {
            this.arraytoupload[item] = this.order.attachment[item]
          } else {
            if (this.order.attachment[item].name) {
              this.arraytoupload[item] = this.order.attachment[item]
            }
          }
        }
      }

      if (this.id === -1 && this.tempid === -1) {
        this.order.attachment = {}
        if (!this.order.statusOrder) this.order.statusOrder = 'compord'
        if (!this.order.primaryCode) this.order.primaryCode = 'draft'
        try {
          this.order.creationDate = new Date().getTime()
          const docRef = await this.$db.collection('orders').add(this.order)
          this.id = docRef.id
          this.order.id = docRef.id
        } catch (err) {
          this.$buefy.notification.open({
            duration: 3000,
            message: err,
            type: 'is-danger',
          })
          this.isSaveDisabled = false

          return
        }
      } else if (this.id === -1) {
        this.id = this.tempid
      }

      // GESTIONE ATTACHMENT
      let orderPath = `order/attachment/${this.order.id}`

      for (const item in this.arraytodelete) {
        await this.$storage.ref(`${orderPath}/${item}`).delete()
        this.order.attachment[item] = null
        this.order.attachmentflag[item] = null
      }
      this.arraytodelete = []

      for (const item in this.arraytoupload) {
        const storageRef = this.$storage.ref(`${orderPath}/${item}`)
        let fileUploaded = await storageRef.put(this.arraytoupload[item])
        let url = await fileUploaded.ref.getDownloadURL()
        this.order.attachment[item] = url
        this.order.attachmentflag[item] = 1
      }
      this.arraytoupload = []

      this.order.lastModificationDate = new Date().getTime()
      this.order.id = this.id
      this.order.deleted = this.order.statusOrder === 'deletedord'
      this.order.history = this.order.history ? this.order.history : []

      this.order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: this.currentStatus,
        newStatus: this.order.statusOrder,
      })

      //const orderRef = this.$db.collection('orders').doc(this.id)
      //await orderRef.update({
      //  searchArray: firebase.firestore.FieldValue.arrayUnion(...this.order.searchArray),
      //})
      //const searchArray = this.order.searchArray
      //delete this.order.searchArray
      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.order.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.order.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.order.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.id)
      batch.update(orderupdate, this.order)
      batch
        .commit()
        .then(() => {
          this.currentStatus = this.order.statusOrder
          //this.order.searchArray = searchArray
          this.isSaveDisabled = false
          //aggiorno l'oggetto per confrontare le modifiche
          this.lastSavedOrder = cloneDeep(this.order)
          //controllo se devo bloccare il form dopo il savataggio
          this.disabledbool = !this.isEditDoable(this.order.statusOrder)
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('order_saved'),
            type: 'is-success',
          })
        })
        .catch(() => {
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })
    },
    async OldInitUpdate() {
      this.isSaveDisabled = true
      //this.order.searchArray = []
      this.order.searchArray = this.generateKeyWord([
        this.order.patient.alias,
        this.order.patient.name, // + ' ' + this.order.patient.surname,
        this.order.patient.surname,
        this.order.primaryCode,
        this.order.id_mercury,
        //this.order.company.name,
        //this.order.shop.name,
        this.order.tec,
      ])
      this.order.scans_sx = []
      this.order.scans_dx = []
      if (this.id == -1) {
        if (this.tempid == -1) {
          let attachment = this.order.attachment
          let realStatus = this.order.statusOrder
          let realprimaryCode = this.order.primaryCode
          this.order.statusOrder = 'draft'
          this.order.primaryCode = 'draft'

          this.order.attachment = {}
          this.order.creationDate = new Date().getTime()
          await this.$db
            .collection('orders')
            .add(this.order)
            .then(docRef => {
              this.id = docRef.id
              this.order.id = docRef.id
              this.order.attachment = attachment
              this.order.statusOrder = realStatus
              this.order.primaryCode = realprimaryCode
            })
        } else {
          this.id = this.tempid
        }
      }
      for (item in this.order.attachment) {
        if (this.order.attachment[item] != null) {
          if (this.order.attachmentflag[item] == 0) {
            this.arraytoupload[item] = this.order.attachment[item]
          } else {
            if (this.order.attachment[item].name) {
              this.arraytoupload[item] = this.order.attachment[item]
            }
          }
        }
      }

      let orderPath = `order/attachment/${this.order.id}`

      for (var item in this.arraytodelete) {
        //var desertRef = this.$storage.ref(
        //  "order/attachment/" + this.order.id + "/" + item
        //);
        //await desertRef.delete().then(function () {});
        //console.log(error);
        //});
        await this.$storage.ref(`${orderPath}/${item}`).delete()
        this.order.attachment[item] = null
        this.order.attachmentflag[item] = null
        //console.log(`deleted ${item}`)
      }
      this.arraytodelete = []

      for (item in this.arraytoupload) {
        const storageRef = this.$storage.ref(`${orderPath}/${item}`)
        let fileUploaded = await storageRef.put(this.arraytoupload[item])
        //console.log(fileUploaded)
        let url = await fileUploaded.ref.getDownloadURL()
        //console.log(url)
        this.order.attachment[item] = url
        this.order.attachmentflag[item] = 1
        //delete this.arraytoupload[item]

        //const storageRef = this.$storage.ref("order/attachment/" + this.order.id + "/" + item);
        //await storageRef
        //  .put(this.arraytoupload[item])
        //  .then(async (snapshot) => {
        //    await snapshot.ref.getDownloadURL().then((url) => {
        //      this.order.attachment[item] = url;
        //      this.order.attachmentflag[item] = 1;
        //      delete this.arraytoupload[item];
        //    });
        //  });
      }

      this.arraytoupload = []

      this.order.lastModificationDate = new Date().getTime()
      this.order.id = this.id
      if (this.order.statusOrder == 'deletedord') {
        this.order.deleted = true
      } else {
        this.order.deleted = false
      }
      if (!this.order.history) {
        this.order.history = []
      }

      this.order.history.push({
        technician: this.$store.getters.user.userInfo.username,
        date: new Date().getTime(),
        oldStatus: this.currentStatus,
        newStatus: this.order.statusOrder,
      })

      var batch = this.$db.batch()
      var lookuppatients = this.$db.collection('patients').doc(this.order.patientId)
      batch.update(lookuppatients, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupshops = this.$db.collection('shops').doc(this.order.shopId)
      batch.update(lookupshops, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var lookupcomp = this.$db.collection('companies').doc(this.order.companyId)
      batch.update(lookupcomp, {
        orders: firebase.firestore.FieldValue.arrayUnion(this.id),
      })
      var orderupdate = this.$db.collection('orders').doc(this.id)
      batch.update(orderupdate, this.order)
      batch
        .commit()
        .then(() => {
          this.currentStatus = this.order.statusOrder

          this.isSaveDisabled = false
          //aggiorno l'oggetto per confrontare le modifiche
          this.lastSavedOrder = cloneDeep(this.order)
          //controllo se devo bloccare il form dopo il savataggio
          this.disabledbool = !this.isEditDoable(this.order.statusOrder)
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('order_saved'),
            type: 'is-success',
          })
        })
        .catch(() => {
          //console.log(err);
          this.isSaveDisabled = false

          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('error_form_server'),
            type: 'is-danger',
          })
        })

      //this.$router.push({ name: "orders" });
    },
    exportJson() {
      this.exportFormOrderJson(this.order, this.id)
    },
    async sendToMercurio() {
      if (this.sendingToMercurio) return
      this.sendingToMercurio = true
      await this.sendFormOrderToMercurio(this.order, this.id)
      this.sendingToMercurio = false
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!isEqual(this.order, this.lastSavedOrder)) {
      if (!window.confirm(this.$translate('confirm_exit_from_order'))) {
        return
      }
    }
    next()
  },
}
</script>
<style scoped>
.container >>> .field-label .label {
  text-align: left;
}
</style>
